import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, required, TopToolbar, Button, useRedirect, DateInput, AutocompleteInput, useGetOne, useNotify, FileInput, FileField } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getNameAndCompanyNamewithAddress } from "../common";

const EstimateHistoryEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams(); 
  const [isPay,setIsPay] = useState(false);
  const [customers,setCustomers]=useState([]);
  const { data, isLoading } = useGetOne("estimateHistory", { id });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(()=>{
    if(!isLoading){
      setIsPay(data.isPay);
    }
  },[isLoading])

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom:-2 }}>
        <TopToolbar>
            <Button
                label="見積詳細表示"
                onClick={() => redirect(`/estimateHistory/show/${id}`)}
                startIcon={<VisibilityIcon />}
            />
        </TopToolbar>
    </Box>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Edit mutationMode="pessimistic"
        mutationOptions={{ 
          onSuccess: () => {
            notify('更新が完了しました', { type: 'success' }); 
            // redirect('list', 'estimateHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            validate={required()}
            allowEmpty
            freeSolo  
          />
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <DateInput source="createEstimateDate" label="見積作成日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
            <DateInput source="requestEstimateDate" label="見積依頼日" style={{marginLeft:"10px"}} inputProps={{ max: '9999-12-31' }}/>
          </div>
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <TextInput source="estimateAmount" label="見積金額(税抜き)" style={{marginRight:"10px"}} />
            <TextInput source="createrName" label="見積作成者"　style={{marginLeft:"10px"}}/>
          </div>
          <FileInput source="documentURL" label="見積書" accept="application/pdf, image/*">
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      </Edit>
    </>
  )

};

export default EstimateHistoryEdit;
